import Vue from 'vue';
import axios from 'axios';


const uiDateFormat = 'DD/MM/YYYY';


export default {
  name: 'CmrContrPnlBooksWalks',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    DataGridOptionsComp: require('@/customcontrols/dataGridOptions/dataGridOptions.vue').default,
    BottomNavButtons: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBottomNavButtons.vue').default,
  },
  props: ['dataObj'],
  watch: {
    "dataGridDataObj.gridOptions.pagination": function (val) {
      this.getBooksWalks();
    },
  },
  data: function () {
    return {
      loader: false,
      dataSource: [],
      dataSourcePaginated: [],
      gridCols: [],
      keyColumn: 'name',
      pageOptions: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      selectedkeys: [],
      totalCount: 0,
      gridChoice: {},
      dataGridDataObj: {
        gridOptions: {
          autoExpand: true,
          pagination: true,
          groupPanel: true,
          columnReordering: false,
          autoClose: false,
        },
        gridOptionsChanged: this.gridOptionsChanged,
        refreshRecords: this.getBooksWalks
      },
      hasNextStep: false,

    }
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadingsAdmin != true)
      this.$router.push('/employeeHome');
    this.$root.$on('billing_group_selected', () => { this.getBooksWalks() });
    this.fillGridCols();
  },
  methods: {
    getBooksWalks() {
      if (this.dataObj == null || this.dataObj.billingGroup == null ||
        this.dataObj.billingGroup.id == null || this.dataObj.billingGroup.id < 0)
        return;

      this.loader = true;
      axios.post('/CaptureMeterReading/GetBooksWalks', { Value: this.dataObj.billingGroup.id })
        .then(response => {
          response.data.items.forEach(item => item.name = '[' + item.bookId + '] Walk: ' + item.walkId);
          this.dataSource = response.data.items;
          if (this.dataGridDataObj.gridOptions.pagination)
            this.pageChange({ pageSize: this.pageOptions.pageSize, pageNumber: this.pageOptions.page });
          else {
            this.dataSourcePaginated = this.dataSource;
          }
            
          this.totalCount = response.data.items.length;
        })
        .catch(e => {
          this.$router.push('/login');
          return false;
        })
        .finally(() => { this.loader = false });
    },
    pageChange(pInfo) {
      let start = pInfo.pageNumber * pInfo.pageSize - pInfo.pageSize;
      let end = start + pInfo.pageSize;

      this.dataSourcePaginated = this.dataSource.slice(start, end);
    },
    calculateCellClass(value) {
      return value.data.problemStatusVal === 0 ? 'recordTypeOrange' :
        value.data.problemStatusVal === 1 ? 'recordTypeGray' :
          value.data.problemStatusVal === 2 ? 'recordTypeBlack' :
            value.data.problemStatusVal === 3 ? 'recordTypeTeal' :
              value.data.problemStatusVal === 4 ? 'recordTypeBlue' :
                value.data.problemStatusVal === 5 ? 'recordTypeGreen' : 'recordTypePurple';

    },
    selectionChanged(info) {

    },
    onRowDblClick(info) { 
      //console.log("infoi", info)
      this.gridChoice = this.dataSource.filter(b => b.bookId == info.data.bookId)[0];
      this.loader = true;
      this.dataObj.selected(this.gridChoice);
      this.loader = false;
      this.hasNextStep = true;
    },
    fillGridCols() {
      this.gridCols = [
        { dataField: 'bookId', name: 'bookId', caption: this.$t('common.Id') },
        { dataField: 'name', name: 'name', caption: this.$t('captureMR.BillingGroups') },
      ]
    },
    gridOptionsChanged(item) {
      //console.log("djdjdj", item)
    }
  },
}
